// export const environment = {
//   envName: 'dev',
//   production: false,
//   icRewardsApiEndPoint: 'http://dev-ifc-api.cherrypicks.com/ifc',
//   googleAnalyticsId:"",
//   apiVer: 'v1',
//   version: '1.0.0'
// };
export const environment = {
  envName: 'prod',
  production: true,
  icRewardsApiEndPoint: 'https://ifc-app-api.ifc.com.hk/ifc',
  googleAnalyticsId:"",
  apiVer: 'v1',
  version: '1.0.0'
};